angular.module('webremote.dashboard').controller('widget_transmissionCockpit', 
function ($scope, $log) {

    // TODO

});
